<div id="layout-wrapper">

  <app-topbar (settingsButtonClicked)="onSettingsButtonClicked()" (mobileMenuButtonClicked)="onToggleMobileMenu()">
  </app-topbar>

  <app-sidebar></app-sidebar>

  <div class="main-content">
    <div class="page-content">
      <!-- Banner Global de Alerta de Suscripción -->
      <app-subscription-alert-banner></app-subscription-alert-banner>

      <!-- content -->
      <app-breadcrumb [breadcrumbs]="breadcrumbs"></app-breadcrumb>
      @if (getValidSucursal() && !validatorsService.reload()) {
      <router-outlet></router-outlet>
      }
      <div class="card flex justify-content-center">
        <p-toast [breakpoints]="{ '920px': { width: '100%', right: '0', left: '0' } }" />
      </div>
    </div>
    <!-- footer -->
    <app-footer></app-footer>

    <app-rightsidebar></app-rightsidebar>
  </div>
  <app-modal-refresh-token></app-modal-refresh-token>
</div>